import { doc, onSnapshot, type Firestore } from 'firebase/firestore';
import { httpsCallable, type Functions } from 'firebase/functions';

import type { UserStore } from '../contracts/users';
import type { User } from '@/lib/types';

export class FirebaseUserStore implements UserStore {
  constructor(private firestore: Firestore, private functions: Functions) {}

  async initializeUserProfile(): Promise<void> {
    const createUser = httpsCallable(this.functions, 'createUser');
    await createUser();
  }

  subscribeUserProfile(
    userId: string,
    onUpdate: (user: User | null) => void,
    onError: (error: Error) => void
  ): () => void {
    const userRef = doc(this.firestore, 'users', userId);
    return onSnapshot(
      userRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          onUpdate(null);
          return;
        }
        onUpdate({
          id: snapshot.id,
          ...snapshot.data(),
        } as User);
      },
      (err) => {
        onError(err as Error);
      }
    );
  }
}
